import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from './DateFormatters';
import { isValueEntered } from 'services/Validation';

/**
 * Check if dateToCheck is before referenceDate
 * @param {Date} referenceDate - the date to check against - i.e. the current start date
 * @param {Date} dateToCheck - the date to use for the check - i.e. todays date
 */
export const isDateBefore = (dateToCheck, referenceDate) => {
    if (referenceDate && dateToCheck) {
        const ref = moment(referenceDate, DEFAULT_DATE_FORMAT);
        const check = moment(dateToCheck, DEFAULT_DATE_FORMAT);
        return check.isBefore(ref);
    }
    return false;
};

/**
 * Check if dateToCheck is after referenceDate
 * @param {Date} referenceDate - the date to check against
 * @param {Date} dateToCheck
 */
export const isDateAfter = (dateToCheck, referenceDate) => {
    if (referenceDate && dateToCheck) {
        const ref = moment(referenceDate, DEFAULT_DATE_FORMAT);
        const check = moment(dateToCheck, DEFAULT_DATE_FORMAT);
        return check.isAfter(ref);
    }
    return false;
};

/**
 * Check if date is between startDate
 * @param {*} startDate 
 * @param {*} endDate 
 */
export const isDateBetween = (startDate, endDate, testDate) => {
    if (startDate && endDate) {
        const start = moment(startDate, DEFAULT_DATE_FORMAT);
        const end = moment(endDate, DEFAULT_DATE_FORMAT);
        var test = moment(testDate, DEFAULT_DATE_FORMAT);
        return test.isBetween(start, end, 'days', true); // true means inclusive of both dates
    }
    return false;
};

/**
 * Check if date is between startDate and the enddate using the full datetime
 * @param {*} startDate 
 * @param {*} endDate 
 * @param {*} testDate 
 */
export const isDateTimeBetween = (startDate, endDate, testDate) => {
    // console.log('s '.concat(startDate));
    // console.log('e '.concat(endDate));
    // console.log('t '.concat(testDate));
    if (startDate && endDate && testDate) {
        return testDate >= endDate && testDate <= startDate;
    }
    return false;
};

/**
 * check if endDate is before the startDate
 * @param {String} name - a date value - either startDate or endDate
 * @param {String} value the date value
 * @param {String} otherDateValue - the other date value
 */
export const validateDateFields = (name, value, otherDateValue) => {
    let formErrors = '';
    switch (name) {
        case 'endDate':
            // check its not before the start date
            if (isValueEntered(value) && isValueEntered(otherDateValue)) {
                if (isDateBefore(moment(value), moment(otherDateValue))) {
                    formErrors = ' are invalid. The end date selected cannot be before the start date';
                }
            }
            break;
        case 'startDate':
            // check its not after the end date
            if (isValueEntered(otherDateValue) && isValueEntered(value)) {
                if (isDateBefore(moment(otherDateValue), moment(value))) {
                    formErrors = ' are invalid. The start date selected cannot be after the end date';
                }
            }
            break;
        default:
            break;
    }
    return formErrors;
};




// WEBPACK FOOTER //
// ./services/DateService.js